import { render, staticRenderFns } from "./PublicationVideoItem.vue?vue&type=template&id=034254c4&scoped=true&lang=pug"
import script from "./PublicationVideoItem.vue?vue&type=script&lang=js"
export * from "./PublicationVideoItem.vue?vue&type=script&lang=js"
import style0 from "./PublicationVideoItem.vue?vue&type=style&index=0&id=034254c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034254c4",
  null
  
)

export default component.exports